// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-team-form__container{
    display: flex;
    align-content: center;    ;
    margin-top: var(--space-and-half);
    justify-content: space-between;
    margin: var(--space) var(--space-x3);
}
.edit-team-form__shield{
    background: var(--white-color);
    flex: 0 0 auto;
    margin-top: var(--space-x2);
    width: calc( calc( var(--space) * 11) + var(--space-quarter));
    height: calc( calc( var(--space) * 11) + var(--space-quarter));
    border-radius: 4px;
    text-align: center;
    vertical-align: middle;
    position: relative;   
    margin-left: var(--space-x3);
}

.edit-team-form__shield__no-photo-icon {
   position: relative;   
   text-align: center;
   vertical-align: middle;
   justify-content: center;
   padding: var(--space-half-quarter);

}

.edit-team-form__shield__team-photo-label { 
   font-family: Roboto;
   font-style: normal;
   font-weight: bolder;
   font-size: 19px;
   line-height: 22px;
   letter-spacing: 0.0025em;   
   color:var(--primary-dark-color);
   margin-bottom: var(--space-half);
}

.edit-team-form__shield img{
    width: calc( calc( var(--space) * 11) + var(--space-quarter));
    height: calc( calc( var(--space) * 11) + var(--space-quarter));
    border-radius: 50%;
}

.edit-team-form__shield .icon-team-2-64{
   font-size: calc(var(--space) *6);
   color: var(--white-color);
}

.edit-team-form__shield span.icon-team-2-64{
   position: relative;
   background: var(--new-icon-color);
   border-radius: 50%;        
   width: 100%;
   height: 100%;
  padding: calc(var(--space) *.75);
}

.edit-team-form__shield__new-button{
   text-align: center;
   justify-content: center;
   margin-top: var(--space-half);
   bottom: 0px;    
   position: relative;   
   color: var(--new-green-color);
   font-family: Roboto;
   font-style: normal;
   font-weight: bold;
   font-size: 19px;
   line-height: 22px;
   display: flex;
   align-items: center;
   letter-spacing: 0.0025em;  
   cursor: pointer; 
}

.edit-team-form__shield__new-button .icon-plus{
    color: var(--primary-dark-color);
    background-color: var(--basic-green-color);
    font-size: var(--space-x2);
    border-radius: 4px;
}

.edit-team-form__form__content{
    padding-left: var(--space-x3);
    padding-top: var(--space-x3);
    width: 70%;
    flex: 1 1 auto;
    margin-left: var(--space-x2);
}
.edit-team-form__form__content-pagename{
    display: flex;
    align-content: flex-start;
    margin-top: var(--space-x3)
}

.edit-team-form__form__input__name{
    width: 100%;
}

.edit-team-form__form__input__pagename{
    width: calc( var(--space-x2) *10 );
    margin-bottom: var(--space-and-half);
}

.edit-team-form__form__input{
    width: calc( var(--space-x2) *10 );
}

.select-field.edit-team-form__form__input .select-field-icon{
    display: none;
}

.select-field.edit-team-form__form__input .MuiInputBase-root{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-normal);
    font-size: var(--space);
    line-height: calc( var(--space-and-half) - 2px );;
    /*display: flex;*/
    align-items: center;
    letter-spacing: 0.005em;
    color: var(--primary-dark-color);
    padding: 0 var(--space-half-quarter);
    width: calc( var(--space-x2) *10 );
}

.select-field.edit-team-form__form__input{
    width: calc( var(--space-x2) *10 );
}

.edit-team-form__header{
    display: flex;
    justify-content: space-between;
    flex-basis: 100%;
}

.edit-team-form__header-subtitle.baloa-headline-4{
    color: var(--primary-dark-color) !important;
    font-size: calc( var(--space-x2) + var(--space-quarter)) !important;
}

.edit-team-form__form__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{
    border: none;
}

.edit-team-form__form__input .MuiInput-underline.select-field-input:before{
    border: none;
    transition: none;
}

.edit-team-form__form__input__gender{
    width: calc( var(--space-x2) *10 );
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.edit-team-form__form__input__gender.baloa-body-2{
    flex-basis: 100%;
    margin-bottom: var(--space-half);
}

.edit-team-form__form__input-gender p{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-bold) !important;
    font-size: calc(var(--space-half-quarter) - 1px);
    line-height: var(--font-normal);
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.04em;
    color: var(--primary-very-dark-color);
}

.edit-team-form__form__input-gender{
    border: 2px solid var(--mid-gray-color);
    border-radius: var(--space-and-half);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: var(--space-half) var(--space);
    height: var(--space-and-half);
    justify-content: center;
}

.edit-team-form__form__input-gender.selected {
    border: 2px solid var(--secondary-light-color);
    border-radius: var(--space-and-half);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--space-half) var(--space);
    height: var(--space-and-half);
}

.edit-team-form__form__input-check.text-alert{
    font-size: calc(var(--space) - 2px);
}

.edit-team__container .tabpanel-line{
    margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-edit-team-form-component/LeagueEditTeamFormComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,iCAAiC;IACjC,8BAA8B;IAC9B,oCAAoC;AACxC;AACA;IACI,8BAA8B;IAC9B,cAAc;IACd,2BAA2B;IAC3B,6DAA6D;IAC7D,8DAA8D;IAC9D,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;GACG,kBAAkB;GAClB,kBAAkB;GAClB,sBAAsB;GACtB,uBAAuB;GACvB,kCAAkC;;AAErC;;AAEA;GACG,mBAAmB;GACnB,kBAAkB;GAClB,mBAAmB;GACnB,eAAe;GACf,iBAAiB;GACjB,wBAAwB;GACxB,+BAA+B;GAC/B,gCAAgC;AACnC;;AAEA;IACI,6DAA6D;IAC7D,8DAA8D;IAC9D,kBAAkB;AACtB;;AAEA;GACG,gCAAgC;GAChC,yBAAyB;AAC5B;;AAEA;GACG,kBAAkB;GAClB,iCAAiC;GACjC,kBAAkB;GAClB,WAAW;GACX,YAAY;EACb,gCAAgC;AAClC;;AAEA;GACG,kBAAkB;GAClB,uBAAuB;GACvB,6BAA6B;GAC7B,WAAW;GACX,kBAAkB;GAClB,6BAA6B;GAC7B,mBAAmB;GACnB,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;GACf,iBAAiB;GACjB,aAAa;GACb,mBAAmB;GACnB,wBAAwB;GACxB,eAAe;AAClB;;AAEA;IACI,gCAAgC;IAChC,0CAA0C;IAC1C,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,UAAU;IACV,cAAc;IACd,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,uBAAuB;IACvB,gDAAgD;IAChD,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,mEAAmE;AACvE;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,wCAAwC;IACxC,gDAAgD;IAChD,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,uCAAuC;IACvC,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uCAAuC;IACvC,6BAA6B;AACjC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".edit-team-form__container{\n    display: flex;\n    align-content: center;    ;\n    margin-top: var(--space-and-half);\n    justify-content: space-between;\n    margin: var(--space) var(--space-x3);\n}\n.edit-team-form__shield{\n    background: var(--white-color);\n    flex: 0 0 auto;\n    margin-top: var(--space-x2);\n    width: calc( calc( var(--space) * 11) + var(--space-quarter));\n    height: calc( calc( var(--space) * 11) + var(--space-quarter));\n    border-radius: 4px;\n    text-align: center;\n    vertical-align: middle;\n    position: relative;   \n    margin-left: var(--space-x3);\n}\n\n.edit-team-form__shield__no-photo-icon {\n   position: relative;   \n   text-align: center;\n   vertical-align: middle;\n   justify-content: center;\n   padding: var(--space-half-quarter);\n\n}\n\n.edit-team-form__shield__team-photo-label { \n   font-family: Roboto;\n   font-style: normal;\n   font-weight: bolder;\n   font-size: 19px;\n   line-height: 22px;\n   letter-spacing: 0.0025em;   \n   color:var(--primary-dark-color);\n   margin-bottom: var(--space-half);\n}\n\n.edit-team-form__shield img{\n    width: calc( calc( var(--space) * 11) + var(--space-quarter));\n    height: calc( calc( var(--space) * 11) + var(--space-quarter));\n    border-radius: 50%;\n}\n\n.edit-team-form__shield .icon-team-2-64{\n   font-size: calc(var(--space) *6);\n   color: var(--white-color);\n}\n\n.edit-team-form__shield span.icon-team-2-64{\n   position: relative;\n   background: var(--new-icon-color);\n   border-radius: 50%;        \n   width: 100%;\n   height: 100%;\n  padding: calc(var(--space) *.75);\n}\n\n.edit-team-form__shield__new-button{\n   text-align: center;\n   justify-content: center;\n   margin-top: var(--space-half);\n   bottom: 0px;    \n   position: relative;   \n   color: var(--new-green-color);\n   font-family: Roboto;\n   font-style: normal;\n   font-weight: bold;\n   font-size: 19px;\n   line-height: 22px;\n   display: flex;\n   align-items: center;\n   letter-spacing: 0.0025em;  \n   cursor: pointer; \n}\n\n.edit-team-form__shield__new-button .icon-plus{\n    color: var(--primary-dark-color);\n    background-color: var(--basic-green-color);\n    font-size: var(--space-x2);\n    border-radius: 4px;\n}\n\n.edit-team-form__form__content{\n    padding-left: var(--space-x3);\n    padding-top: var(--space-x3);\n    width: 70%;\n    flex: 1 1 auto;\n    margin-left: var(--space-x2);\n}\n.edit-team-form__form__content-pagename{\n    display: flex;\n    align-content: flex-start;\n    margin-top: var(--space-x3)\n}\n\n.edit-team-form__form__input__name{\n    width: 100%;\n}\n\n.edit-team-form__form__input__pagename{\n    width: calc( var(--space-x2) *10 );\n    margin-bottom: var(--space-and-half);\n}\n\n.edit-team-form__form__input{\n    width: calc( var(--space-x2) *10 );\n}\n\n.select-field.edit-team-form__form__input .select-field-icon{\n    display: none;\n}\n\n.select-field.edit-team-form__form__input .MuiInputBase-root{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-normal);\n    font-size: var(--space);\n    line-height: calc( var(--space-and-half) - 2px );;\n    /*display: flex;*/\n    align-items: center;\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color);\n    padding: 0 var(--space-half-quarter);\n    width: calc( var(--space-x2) *10 );\n}\n\n.select-field.edit-team-form__form__input{\n    width: calc( var(--space-x2) *10 );\n}\n\n.edit-team-form__header{\n    display: flex;\n    justify-content: space-between;\n    flex-basis: 100%;\n}\n\n.edit-team-form__header-subtitle.baloa-headline-4{\n    color: var(--primary-dark-color) !important;\n    font-size: calc( var(--space-x2) + var(--space-quarter)) !important;\n}\n\n.edit-team-form__form__input .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{\n    border: none;\n}\n\n.edit-team-form__form__input .MuiInput-underline.select-field-input:before{\n    border: none;\n    transition: none;\n}\n\n.edit-team-form__form__input__gender{\n    width: calc( var(--space-x2) *10 );\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.edit-team-form__form__input__gender.baloa-body-2{\n    flex-basis: 100%;\n    margin-bottom: var(--space-half);\n}\n\n.edit-team-form__form__input-gender p{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-bold) !important;\n    font-size: calc(var(--space-half-quarter) - 1px);\n    line-height: var(--font-normal);\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.04em;\n    color: var(--primary-very-dark-color);\n}\n\n.edit-team-form__form__input-gender{\n    border: 2px solid var(--mid-gray-color);\n    border-radius: var(--space-and-half);\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    padding: var(--space-half) var(--space);\n    height: var(--space-and-half);\n    justify-content: center;\n}\n\n.edit-team-form__form__input-gender.selected {\n    border: 2px solid var(--secondary-light-color);\n    border-radius: var(--space-and-half);\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: var(--space-half) var(--space);\n    height: var(--space-and-half);\n}\n\n.edit-team-form__form__input-check.text-alert{\n    font-size: calc(var(--space) - 2px);\n}\n\n.edit-team__container .tabpanel-line{\n    margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
